import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import ReactHtmlParser from "react-html-parser";

import PropTypes from "prop-types";

import "./Style";

class MatterportContainer extends Component {
  constructor() {
    super();

    this.state = {
      error: null,
      errorInfo: null,
    };
  }

  componentDidCatch(error, errorInfo) {
    this.setState(
      {
        error,
        errorInfo,
      },
      () => {
        console.error(error, errorInfo);
      }
    );
  }

  componentDidMount() {
    window.addEventListener("message", (e) => {
      console.log("post-m-story", e.data);
      const { presentation } = e.data;
      if (presentation) {
        this.setState({
          presentation: true,
        });
      }
    });
  }

  render() {
    const { matterport, matterportType, matterportTitle, tourType } = this.props;
    const { error } = this.state;

    if (!matterport.length || error) {
      return null;
    }

    let matterportBlock = null;

    matterportBlock = matterport.map((item, i) => {
      if (item.custom_content_type === "id") {
        let matterportFlags = "";
        switch (tourType) {
          case "branded":
          case "":
            matterportFlags = "&brand=1&vr=1&";
            break;
          case "unbranded":
            matterportFlags = "&brand=0&vr=1&";
            break;
          case "restricted":
            matterportFlags = "&brand=0&vr=0&title=0&mls=1";
            break;
        }
        const matterportSource = `https://my.matterport.com/show/?m=${item.content}&play=0&wh=0&ts=2&guides=0${matterportFlags}`;
        return (
          <div
            key={i}
            className="matterport-component"
            style={
              this.state.presentation
                ? { height: document.body.offsetWidth * (3 / 4) }
                : {}
            }
          >
            <h2 className="section-header">{item.title || "3D Walkthrough"}</h2>
            <div className="iframe-container">
              <iframe
                src={matterportSource}
                frameBorder="0"
                allowFullScreen
              ></iframe>
            </div>
          </div>
        );
      } else {
        return (
          <div
            className="matterport-component"
            style={
              this.state.presentation
                ? { height: document.body.offsetWidth * (3 / 4) }
                : {}
            }
          >
            <h2 className="section-header">
              {item.title || "3D Walkthrough"}
            </h2>
            <div className="iframe-container">
              {ReactHtmlParser(item.content)}
            </div>
          </div>
        );
      }
    });

    return (
      <div id="matterport" className="matterport-container">
        {matterportBlock}
      </div>
    );
  }
}

MatterportContainer.propTypes = {
  matterport: PropTypes.array.isRequired,
  matterportType: PropTypes.string.isRequired,
  matterportTitle: PropTypes.string.isRequired,
  tourType: PropTypes.string.isRequired,
};

const mapStateToProps = (state) => {
  return {
    matterport: state.matterport.matterport,
    matterportType: state.matterport.matterportType,
    matterportTitle: state.matterport.matterportTitle,
    tourType: state.app.tourType,
    getTourFulfilled: state.app.getTourFulfilled,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {};
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(MatterportContainer);
